// extracted by mini-css-extract-plugin
export var originalPrice = "_w0-0";